import React from "react";
import { strings } from "../../Translations/strings";
import "./DataProtectionOfficer.scss";
import NavProducts from "../../Marketplace/NavProducts/NavProducts";
import Footer from "../../Common/Footer/Footer";

const DataProtectionOfficer = () => {
  return (
    <>
      <NavProducts />
      <div className="data-protection-officer-page">
        <div className="container">
          <div className="data-protection-officer-content">
            <h1 className="page-title">{strings.nav_data_protection_officer_label}</h1>
            <div className="content-section">
              <div className="officer-header">
                <h2 className="officer-title">Službenik za zaštitu ličnih podataka | Partner mikrokreditna fondacija Tuzla</h2>
              </div>

              <div className="policy-section">
                <h3>Obavještenje o imenovanju Službenika za zaštitu ličnih podataka</h3>
                <p>
                  U skladu sa članom 41. Zakona o zaštiti ličnih podataka Bosne i Hercegovine 
                  ("Službeni glasnik BiH", broj 12/25), imenovan je Službenik za zaštitu ličnih podataka.
                </p>
              </div>

              <div className="policy-section">
                <p>
                  Za sva pitanja u vezi sa obradom i zaštitom ličnih podataka, kao i ostvarivanjem vaših 
                  prava, možete kontaktirati našeg Službenika za zaštitu ličnih podataka putem 
                  sljedećih kontakt podataka:
                </p>
                
                <div className="contact-info">
                  <div className="contact-item">
                    <strong>e-mail:</strong> <a href="mailto:sszlp@partner.ba">sszlp@partner.ba</a>
                  </div>
                  
                  <div className="contact-item">
                    <strong>putem pošte na adresu:</strong>
                    <div className="address">
                      <p>Partner mikrokreditna fondacija Tuzla</p>
                      <p>n/r Službenik za zaštitu ličnih podataka</p>
                      <p>ul. 15 maj bb, 75000 Tuzla</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DataProtectionOfficer;
